import { useQuery } from '@tanstack/vue-query'

import { explorerApi } from '~/api/client'
import { type EvmGeneralSummaryInfo } from '~/api/repository'
import { generalSummaryKey } from '~/api/service/query-keys.const'

export const useFetchGeneralSummary = () => {
  return useQuery([ ...generalSummaryKey ], () => {
    return explorerApi.generalController.getHomeGeneralSummary().then((res) => {
      return generalSummaryDto(res as EvmGeneralSummaryInfo)
    })
  })
}

export type ViewGeneralSummaryInfo = EvmGeneralSummaryInfo & {
  price: string;
  price24h: string;
  gasTracker: string;
  dailyTransactions: string;
  averageBlockTime: string;
}

const generalSummaryDto = (info: EvmGeneralSummaryInfo): ViewGeneralSummaryInfo => {
  return {
    ...info,
    price: `$${setComma(setDecimal(info.PRC, 2))}`,
    price24h: setComma(setDecimal(info.PRC24H, 2)),
    gasTracker: `${setComma(info.GTKR)} gwei`,
    dailyTransactions: `${setComma(info.DTRXCNT)} txns`,
    averageBlockTime: `${setComma(info.AVGBT)} secs`,
  }
}